﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------
import SoPLogo from "~irad-resources/Logos/SoPLogoMask.svg?url";
import * as React from "react";
import type { StartPageCustomizations } from "~base/Pages/Home/Start";
import { StartPageDefaultCustomization } from "~base/Pages/Home/Start";
import type { OrganizationIdentifierSubTypes } from "~base/Internationalization/ConfigurationInfo";
import type { IntlContext } from "~base/Internationalization/IntlContext";
import type * as sessionModel from "~base/Services/API/Session/Model";

const customStyling = {
    header: {
        padding: "25px 33px 0px 8px",
    },
};

export default {
    userInfoCustomization: {
        pictureFrame: (
            <img
                src={SoPLogo}
                style={{
                    width: "50px",
                    paddingTop: "5px",
                }}
            />
        ),
    },
    customStyles: {
        ...StartPageDefaultCustomization.customStyles,
        ...customStyling,
    },
    allowSelfServiceLanguageSelection: true,
    additionalAllowedOrganizationTypes: [
        "DödsboSE",
        "UtländsktBolagSE",
    ] as Array<OrganizationIdentifierSubTypes>,
    formatSessionDisplayName: (
        intl: IntlContext,
        session: sessionModel.Session,
        sessionModelInfo: sessionModel.GetStartInfoSessionModel
    ) => {
        const displayValue = intl.formatDateWithTime(session.creationDate);

        if (session.access == "Read") {
            return displayValue + " *";
        }
        return displayValue;
    },
    requireSessionModelSelection: (sessionModels) =>
        sessionModels.some((m) =>
            requiresActiveModelSelection(m.SessionModelFqn)
        ),
} as StartPageCustomizations;

function requiresActiveModelSelection(fqn: string): boolean {
    switch (fqn) {
        case "SoP.Consilio.Rådgivningssession.Person.Securities.SecuritiesRS":
        case "SoP.Consilio.Rådgivningssession.Person.WealthManagementInvestmentAdvice.WealthManagementInvestmentAdviceSM":
        case "SoP.Consilio.Rådgivningssession.Företag.WealthManagementInvestmentAdvice.WealthManagementInvestmentAdviceCompanySM":
        case "SoP.Consilio.Rådgivningssession.Företag.WealthManagement.WealthManagementFöretagRS":
        case "SoP.Consilio.Rådgivningssession.Företag.WealthManagement.Inst.WealthManagementFöretagInstRS":
            return true;
        default:
            return false;
    }
}
